export default __webpack_public_path__ + "static/media/1.c9c38fb9.png";